import React, { useState } from 'react';
import styled from 'styled-components';
import { calc4k } from '../utilities';
import Hero__Slide from './Hero__Slide';
import useInterval from "../hooks/useInterval";

export default function( { slides, duration, size, vignette } ) {

    const [active, setActive] = useState( 0 );

    if( slides.length > 1 ) {
        useInterval(() => {
            setActive( slides.length - 1 === active ? 0 : active + 1 );
        }, duration || 2000 );
    }

    const outputSlides = () => {
        let slideArray = [];
        slides.forEach( ( slide, index ) => {
            slideArray.push(
                <Hero__Slide
                    key={ `hero-slide-${ index }` }
                    vignette={ vignette }
                    active={ index === active }
                    { ...slide } />
            );
        } );
        return slideArray;
    };

    return (
        <Hero size={ size }>
            { outputSlides() }
        </Hero>
    );
}

const Hero = styled.div`
    height: ${p => {
        switch( p.size ) {
            case 'tall':
                return calc4k(2724);
            case 'elevator':
                return calc4k(1580);
            case 'full':
                return '100vh';
            default:
                return calc4k(1916);
        }
    }};
    position: relative;
    z-index: 0;   
`;
